import AppCues from './AppCues';
const INTERCOM_APP_ID = 'sa8p3fk0';

export { AppCues, INTERCOM_APP_ID };
